// DO NOT EDIT -- generated from fs/services/alexa/search_service_types.proto

import { BadClickType, ConversionParams, CoreWebVitalType, CustomEvent, Dimension, DimensionFilter, DimensionType, DimensionValueStats, Opportunity, PageView, SeenEvent, Signal } from './conversions.proto';
import { Clip, Datum, MultiDatum, Session } from './search.proto';
import { GeneratedSearchie, SearchUser, SearchieHandle } from './searchies.proto';
import * as pagination from '../../shared/pagination';
import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';

export interface ApiSession {
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  createdTime: protobuf.timestamp | null;
  fsUrl: string;
  customEvents: ApiSession.CustomEvent[];
}

export namespace ApiSession {
  export interface CustomEvent {
    eventStart: protobuf.timestamp | null;
    eventCustomName: string;
    vars: vars.Var[];
  }
}

export interface QueryRequest {
  orgId: string;
  /** TODO(nishanth): deprecate this in favor of a structured type */
  solrRequestJson: protobuf.bytes;
  disallowPartialResults: boolean;
  /** Static name, ideally upper camelcase (i.e. SessionCount) to be recorded for metrics. Do not use a dynamic value here! */
  source: string;
  params: Param[];
}

export interface Param {
  key: string;
  value: string;
}

export interface QueryResponse {
  noCollection: boolean;
  solrResponseJson: protobuf.bytes;
}

export interface DailyActivesThresholdRequest {
  orgId: string;
  segmentDefinition: segment.SegmentDefinition | null;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  timezone: string;
  windowSize: protobuf.duration | null;
  /**
   * Set disallow_partial_results to true if you require full results, preferring failure over receiving partial data.
   * If success, returned data is guaranteed to be full results for the requested segment and window.
   */
  disallowPartialResults: boolean;
}

export interface CountResponse {
  value: protobuf.int64;
}

export interface GenerateSearchieCacheKey {
  request: GenerateSearchieRequestProto | null;
  searchCacheKey: search.CacheKey | null;
}

export interface GenerateSearchieRequestProto {
  /** Org ID for which the searchie should be generated. */
  orgId: string;
  /** The searchie handle defining parameters for generation. */
  handle: SearchieHandle | null;
  /** Optional timezone for which the searchie should be generated, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /**
   * Optional granularization for which searchie queries will be cached.
   * Use sparingly! Do not set low granularizations for expensive searchies.
   * A sane default will be provided by the application when omitted.
   */
  granularization: protobuf.duration | null;
  /**
   * CacheOptions is options for the query cache. A sane default will be
   * provided by the application if any fields are omitted.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * FollowUp indicates whether this request is the initial request for a
   * searchie or a follow-up request.
   * 
   * Each GenerateSearchie request could be part of a sequence of requests
   * in which the initial request is for cached, potentially old data that
   * can be returned quickly and subsequent requests are for fresher data
   * that may take longer to compute.
   * 
   * The value has no effect on the data returned; it is only used to
   * differentiate between requests for the purpose of metrics.
   */
  followUp: boolean;
  /**
   * If set, opts in to sampling.
   * Results will be extrapolated based on sample percent.
   * Note: Only some searchies support sampling! If not supported, an invalid request error will be returned.
   */
  sampleOptions: SampleOptions | null;
}

export interface GenerateSearchieResponseProto {
  /** The generated searchie, including the echoed back handle and corresponding searchie data. */
  generatedSearchie: GeneratedSearchie | null;
  /** ComputedAt is when the searchie data was computed. */
  computedAt: protobuf.timestamp | null;
  /** If non empty, a reference id for which the background computation can be managed. */
  backgroundRefId: string;
  /**
   * CacheOptions is the cache options that were used to generate the
   * searchie.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * If set, indicates sample result details.
   * If unset or underlying percent is 100, response contains full resolution data with no options to follow up iteratively.
   */
  sampleResults: SampleResults | null;
}

/**
 * Common search request parameters shared across various search endpoints.
 * 
 * @deprecated
 */
export interface SearchRequest {
  segmentDefinition: segment.SegmentDefinition | null;
  /**
   * When event search is supplied, it specifies the exact segment, matching behavior, and select configuration for
   * the API. When set, any segment definition or additional segment definitions from other fields are ignored.
   * Whether or not this value is respected is API specific (due to the shared nature of SearchRequest).
   */
  eventSearch: search.EventSearch | null;
  indvId: protobuf.int64;
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  start: number;
  limit: number;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** IANA name of the timezone. */
  timezone: string;
}

export interface SearchPreviewsCacheKey {
  request: SearchPreviewsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export enum SearchPreviewsField {
  SEARCH_PREVIEWS_FIELD_INVALID = 0,
  SEARCH_PREVIEWS_FIELD_RAW_CSS = 1,
  SEARCH_PREVIEWS_FIELD_TEXT = 2,
  /** Return the full url, url path, and page id */
  SEARCH_PREVIEWS_FIELD_URL = 3
}

export interface SearchPreviewsRequest {
  orgId: string;
  event: segment.Event | null;
  timeRange: segment.TimeRange | null;
  limit: number;
  /** Additional fields to return with each preview. */
  additionalFields: SearchPreviewsField[];
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  cacheOptions: QueryCacheOptions | null;
}

export interface SearchPreviewsResponse {
  previews: SearchPreviewsResponse.Preview[];
  computedAt: protobuf.timestamp | null;
  /** If non empty, a reference id for which the background computation can be managed. */
  backgroundRefId: string;
}

export namespace SearchPreviewsResponse {
  export interface Preview {
    userId: protobuf.int64;
    sessionId: protobuf.int64;
    pageId: protobuf.int64;
    /** in millis */
    eventPageOffset: number;
    nativePlatform: segment.NativePlatform;
    /** These values will only be set if the corresponding field was requested in the request. */
    additionalFieldValues: SearchPreviewsResponse.AdditionalFieldValues | null;
  }

  export interface AdditionalFieldValues {
    rawCss: string;
    text: string;
    urlFull: string;
    urlPath: string;
    pageDefId: number;
  }
}

export interface SearchSessionsCacheKey {
  request: SearchSessionsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface SearchSessionsRequest {
  orgId: string;
  searchRequest: SearchRequest | null;
  /**
   * Additional segment definitions is a list of optional segments whose events
   * should be present in returned clips or sessions.
   * 
   * When multiple segments are provided, a returned clip or session
   * will contain all the events from across every supplied segment.
   * The events corresponding to a supplied segment may be
   * interspersed at any point relative to events corresponding to other segments.
   */
  additionalSegmentDefinitions: segment.SegmentDefinition[];
  /**
   * CacheOptions is options for the query cache. If required fields are
   * unspecified, caching will be disabled.
   */
  cacheOptions: QueryCacheOptions | null;
}

/**
 * A list of search results from calling SearchSessions.
 * Warning: It is possible that a clip result contain references to session ids that are not present in session results.
 *          This is because sessions is built from session tips, which are refreshed only periodically. Thus, a clip can
 *          be found whose session does not yet have a session tip record.
 */
export interface SearchSessionsResponse {
  sessions?: SearchSessionsResponse.SessionsResult | null;
  clips?: SearchSessionsResponse.ClipsResult | null;
}

/**
 * A list of search results from calling SearchSessions.
 * Warning: It is possible that a clip result contain references to session ids that are not present in session results.
 *          This is because sessions is built from session tips, which are refreshed only periodically. Thus, a clip can
 *          be found whose session does not yet have a session tip record.
 */
export namespace SearchSessionsResponse {
  /**
   * The result is chosen based on the request segment.
   * For request segment that doesn't have the possibility of spanning multiple sessions, session results will be returned.
   * Otherwise, clip results will be returned.
   */
  export enum result {
    sessions = 1,
    clips = 2
  }

  /**
   * The result is chosen based on the request segment.
   * For request segment that doesn't have the possibility of spanning multiple sessions, session results will be returned.
   * Otherwise, clip results will be returned.
   */
  export function result_oneof(m: SearchSessionsResponse): { opt: result.clips, val: SearchSessionsResponse.ClipsResult } | { opt: result.sessions, val: SearchSessionsResponse.SessionsResult } | null {
    if (m.sessions != null) { return { opt: result.sessions, val: m.sessions } }
    if (m.clips != null) { return { opt: result.clips, val: m.clips } }
    return null;
  }

  export interface SessionsResult {
    /** The the entire list of sessions for the specified user. */
    sessions: Session[];
  }

  export interface ClipsResult {
    /** The events that matched the segment. */
    clips: Clip[];
  }
}

export interface FetchSessionMarkersRequest {
  orgId: string;
  searchRequest: SearchRequest | null;
}

export interface FetchSessionMarkersResponse {
  clips: Clip[];
}

export interface GenerateSignalsCacheKey {
  request: GenerateSignalsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

/** Next ID: 16 */
export interface GenerateSignalsRequest {
  orgId: string;
  /**
   * Basic Conversion parameters which include the
   * Time range, funnel and segment
   */
  conversionParams: ConversionParams | null;
  /** User provided signal types */
  customEvents: CustomEvent[];
  definedEvents: search_settings.DefinedEvent[];
  seenEvents: SeenEvent[];
  pageViews: PageView[];
  /** Determines the "type" of bad clicks we generate signals for. */
  badClicks: BadClickType[];
  /** generate performance signals for supplied thresholds. */
  performanceThresholds: protobuf.int64[];
  /** generates ajax error signals when set */
  ajaxErrors: boolean;
  /**
   * generates core web vitals signals when set
   * 
   * @deprecated
   */
  coreWebVitals: boolean;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone for which the Signals should be generated, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions for the query cache. The skip_cache field is ignored. If
   * required fields are unspecified, the server will substitute default
   * values.
   */
  cacheOptions: QueryCacheOptions | null;
  /** Determines which web vitals we generate signals for */
  webVitals: CoreWebVitalType[];
}

/** A list of Signals from calling GenerateSignals */
export interface GenerateSignalsResponse {
  signals: Signal[];
}

export interface CountDocsRequest {
  orgId: string;
  timeRange: segment.TimeRange | null;
  kind: CountDocsRequest.CountKind;
}

export namespace CountDocsRequest {
  export enum CountKind {
    COUNT_KIND_INVALID = 0,
    COUNT_KIND_INDIVIDUAL = 1,
    COUNT_KIND_USER = 2,
    COUNT_KIND_SESSION = 3,
    COUNT_KIND_PAGE = 4,
    COUNT_KIND_EVENT = 5
  }
}

export interface CountDocsResponse {
  count: protobuf.int64;
}

/** QueryCacheOptions is options for the search query cache. */
export interface QueryCacheOptions {
  /** GetIfAgeLessThan is the maximum age of a cached result that a client is willing to accept. */
  getIfAgeLessThan: protobuf.duration | null;
  /**
   * ComputeIfOlderThan represents the duration that if the cached result is
   * older than, then the server must freshen the result in the background.
   */
  computeIfOlderThan: protobuf.duration | null;
  /** SkipCache, if true, indicates to ignore all caching. No other fields need to be provided. */
  skipCache: boolean;
  queue: QueryCacheOptions.Queue;
}

/** QueryCacheOptions is options for the search query cache. */
export namespace QueryCacheOptions {
  export enum Queue {
    /** will get default treatment */
    QUEUE_INVALID = 0,
    /** queue for synchronous foreground requests */
    QUEUE_FOREGROUND = 1,
    /** queue for asynchronous background requests */
    QUEUE_BACKGROUND = 2
  }
}

export interface GetIndividualRequest {
  orgId: string;
  /** The individual id of the user to fetch. */
  indvId: protobuf.int64;
  /** If supplied, sessions will also be fetched. */
  userIdSessionIds: GetIndividualRequest.UserIdSessionId[];
}

export namespace GetIndividualRequest {
  export interface UserIdSessionId {
    userId: protobuf.int64;
    sessionId: protobuf.int64;
  }
}

export interface GetIndividualResponse {
  /** The user matching the request params. */
  user: SearchUser | null;
  /** Populated if user sessions were requested. */
  sessions: Session[];
}

export interface ComputeElementStatsCacheKey {
  request: ComputeElementStatsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface ComputeElementStatsRequest {
  orgId: string;
  searchRequest: SearchRequest | null;
  pageUrl: string;
  /** Optional. If a selector is included, only send back stats for the given selector. */
  selector: string;
  clusterId: protobuf.int64;
  statsType: ComputeElementStatsRequest.StatsType;
  /**
   * CacheOptions is options for the query cache. A sane default will be
   * provided by the application if any fields are omitted.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * Setting these 2 PageView fields tells the API to rollup up results by PageDefinition instead of ClusterId
   * The page_view_url and start will be used to lookup the associated PageView SOLR event.
   */
  pageViewUrl: string;
  pageViewStart: protobuf.int64;
  includeNamedElements: boolean;
  /** We need to include the page name so that we consider the page definitions created via the page vars api */
  pageViewName: string;
  /** If page_def_id is included the search will use it instead of page_view_name or page_view_url + page_view_start */
  pageDefId: number;
  platform: segment.Platform;
  os: segment.OS;
  appName: string;
}

export namespace ComputeElementStatsRequest {
  export enum StatsType {
    STATS_TYPE_INVALID = 0,
    STATS_TYPE_ALL_CLICKS = 1,
    STATS_TYPE_DEAD_CLICKS = 2,
    STATS_TYPE_ERROR_CLICKS = 3,
    STATS_TYPE_RAGE_CLICKS = 4
  }
}

/** Next ID: 5 */
export interface ComputeElementStatsResponse {
  /** Total matching individuals. NOT term facet count. */
  numMatchingIndividuals: protobuf.int64;
  /** Stats type for which the facet result was generated (from the request). */
  statsType: ComputeElementStatsRequest.StatsType;
  canonicalPageUrl: string;
  countResult?: ComputeElementStatsResponse.CountResult | null;
  /** PageDefId represents the matching value found in SOLR when passing page_view_url to the API. */
  pageDefId: number;
  /** Start time of the earliest PageView SOLR doc seen in the supplied time range. */
  pageViewEventStart: protobuf.timestamp | null;
}

/** Next ID: 5 */
export namespace ComputeElementStatsResponse {
  export enum result {
    countResult = 3
  }

  export function result_oneof(m: ComputeElementStatsResponse): { opt: result.countResult, val: ComputeElementStatsResponse.CountResult } | null {
    if (m.countResult != null) { return { opt: result.countResult, val: m.countResult } }
    return null;
  }

  export interface CountResult {
    /** Total count on this page (for the given stats type), across all matching users. */
    total: protobuf.int64;
    /**
     * Counts (for the given stats type) per unique selector (term) along with user counts for each term.
     * These are concrete CSS selector results.
     */
    counts: MultiDatum[];
    /**
     * These are results that are only Named Elements. The label is the datastore id for the Named Element and
     * the counts are the counts returned via solr.
     */
    namedElementCounts: MultiDatum[];
    /**
     * These are results that are broken out by property.
     * Both element and selector counts are represented here. The label is an element id or selector accordingly.
     */
    elementPropertyCounts: ComputeElementStatsResponse.MultiDatumElementProperty[];
    /**
     * The number of unique users matching the given stats type. (E.g., if a user rage clicked on multiple elements
     * on a page, they are only counted as one user here).
     */
    uniqueUsers: protobuf.int64;
  }

  export interface MultiDatumElementProperty {
    labelKind: ComputeElementStatsResponse.MultiDatumElementProperty.LabelKind;
    datum: MultiDatum | null;
    propertyValue: string;
  }

  export namespace MultiDatumElementProperty {
    export enum LabelKind {
      LABEL_KIND_INVALID = 0,
      LABEL_KIND_ELEMENT = 1,
      LABEL_KIND_SELECTOR = 2
    }
  }
}

export interface ComputeScrollMapsStatsCacheKey {
  request: ComputeScrollMapsStatsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface ComputeScrollMapsStatsRequest {
  orgId: string;
  searchRequest: SearchRequest | null;
  pageUrl: string;
  pageDevice: string;
  clusterId: protobuf.int64;
  statsType: ComputeScrollMapsStatsRequest.StatsType;
  /**
   * CacheOptions is options for the query cache. A sane default will be
   * provided by the application if any fields are omitted.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * Setting these 2 PageView fields tells the API to rollup up results by PageDefinition instead of ClusterId
   * The page_view_url and start will be used to lookup the associated PageView SOLR event.
   */
  pageViewUrl: string;
  pageViewStart: protobuf.int64;
  /** We need to include the page name so that we consider the page definitions created via the page vars api */
  pageViewName: string;
  /** If page_def_id is included the search will use it instead of page_view_name or page_view_url + page_view_start */
  pageDefId: number;
  /** If spec_id is included the search will use it instead of any page related items */
  specId: string;
}

export namespace ComputeScrollMapsStatsRequest {
  export enum StatsType {
    STATS_TYPE_INVALID = 0,
    STATS_TYPE_SCROLL_DEPTH_COUNTS = 1
  }
}

/** NEXT ID: 6 */
export interface ComputeScrollMapsStatsResponse {
  /** Total Matching Individuals, not visits or document count. */
  numMatchingIndividuals: protobuf.int64;
  /** Stats type for which the facet result was generated (from the request). */
  statsType: ComputeScrollMapsStatsRequest.StatsType;
  medianPageFold: protobuf.int64;
  canonicalPageUrl: string;
  scrollDepthCountsResult?: ComputeScrollMapsStatsResponse.ScrollDepthCountsResult | null;
  /** PageDefId represents the matching value found in SOLR when passing page_view_url to the API. */
  pageDefId: number;
  /** Start time of the earliest PageView SOLR doc seen in the supplied time range. */
  pageViewEventStart: protobuf.timestamp | null;
}

/** NEXT ID: 6 */
export namespace ComputeScrollMapsStatsResponse {
  export enum result {
    scrollDepthCountsResult = 3
  }

  export function result_oneof(m: ComputeScrollMapsStatsResponse): { opt: result.scrollDepthCountsResult, val: ComputeScrollMapsStatsResponse.ScrollDepthCountsResult } | null {
    if (m.scrollDepthCountsResult != null) { return { opt: result.scrollDepthCountsResult, val: m.scrollDepthCountsResult } }
    return null;
  }

  export interface ScrollDepthCountsResult {
    /** Total count on this page (for the given stats type), across all matching users. */
    totalDocs: protobuf.int64;
    /** Total number of page visits. This will be the maximum value in the counts MultiDatum */
    totalVisits: protobuf.int64;
    /**
     * The raw count of page visits where a user scrolled X percentage down the page
     * For example a label value pair of 20:79 means 79 users scrolled down to 20% of the page depth
     */
    counts: MultiDatum[];
    /**
     * The internal scroll selectors. This is populated if the page is an internal scroll. Due to possibility of
     * layout and elements changes between browsers, the scroll map should be applied to first found element with
     * highest count. If empty, then apply scroll map to document.
     */
    internalScrollSelectorCounts: Datum[];
  }
}

export interface GenerateOpportunitiesRequest {
  orgId: string;
  /**
   * Basic Conversion parameters which include the
   * Time range, funnel and segment
   */
  conversionParams: ConversionParams | null;
  /**
   * Signals (inputs) are used to generate opportunities (impacts)
   * A signal is defined as an event or a property that can be experienced
   * or is a matching property of the user.
   */
  signals: Signal[];
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions for the query cache. skip_cache field
   * is ignored. If either of the other two fields are
   * missing, we will use the default options.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface GenerateOpportunitiesResponse {
  /** the list of generated opportunities. */
  opportunities: Opportunity[];
}

export interface ComputeDimensionsRequest {
  orgId: string;
  /**
   * Basic Conversion parameters which include the
   * Time range, funnel and segment for the selected Opportunity
   */
  conversionParams: ConversionParams | null;
  /**
   * Signal (input) used to by ComputeDimensions to determine the Affected/Unaffected counts.
   * A signal is defined as an event or a property that can be experienced or is a matching property of the user.
   */
  signal: Signal | null;
  /** The beginning step of the selected Conversions Opportunity. This is a zero-based index. */
  impactStep: protobuf.int64;
  /**
   * The list of the Dimension Types to calculate for the selected Opportunity. If all Dimension types are selected,
   * then the dimension_types field can be left blank.
   */
  dimensionTypes: DimensionType[];
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions for the query cache. skip_cache field
   * is ignored. If either of the other two fields are
   * missing, we will use the default options.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeDimensionsResponse {
  /** List of the calculated Dimensions. Each Dimension contains the statistics for a given DimensionType. */
  dimensions: Dimension[];
}

export interface GenerateDimensionFiltersCacheKey {
  request: GenerateDimensionFiltersRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface GenerateDimensionFiltersRequest {
  orgId: string;
  /**
   * Basic Conversion parameters which include the
   * Time range, funnel and segment for the selected Opportunity
   */
  conversionParams: ConversionParams | null;
  /**
   * Signal (input) used to by ComputeDimensions to determine the Affected/Unaffected counts.
   * A signal is defined as an event or a property that can be experienced or is a matching property of the user.
   */
  signal: Signal | null;
  /** The beginning step of the selected Conversions Opportunity. This is a zero-based index. */
  impactStep: protobuf.int64;
  /**
   * The list of the Dimension Types to calculate for the selected Opportunity. If all Dimension types are selected,
   * then the dimension_types field can be left blank.
   */
  dimensionTypes: DimensionType[];
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions for the query cache. skip_cache field
   * is ignored. If either of the other two fields are
   * missing, we will use the default options.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface GenerateDimensionFiltersResponse {
  /** List of the DimensionFilters, */
  dimensionFilters: DimensionFilter[];
  /** ComputedAt is when the Filters were queried. */
  computedAt: protobuf.timestamp | null;
}

export interface ComputeDimensionStatsRequest {
  orgId: string;
  /**
   * Basic Conversion parameters which include the
   * Time range, funnel and segment for the selected Opportunity
   */
  conversionParams: ConversionParams | null;
  /**
   * Signal (input) used to by ComputeDimensions to determine the Affected/Unaffected counts.
   * A signal is defined as an event or a property that can be experienced or is a matching property of the user.
   */
  signal: Signal | null;
  /** The beginning step of the selected Conversions Opportunity. This is a zero-based index. */
  impactStep: protobuf.int64;
  /**
   * The list of the Dimension Types to calculate for the selected Opportunity. If all Dimension types are selected,
   * then the dimension_types field can be left blank.
   */
  dimensionTypes: DimensionType[];
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /** List of DimensionFilters to apply as dependent filters when calculating stats */
  dimensionFilters: DimensionFilter[];
  /**
   * CacheOptions for the query cache. skip_cache field
   * is ignored. If either of the other two fields are
   * missing, we will use the default options.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeDimensionStatsResponse {
  /** List of the calculated Dimension statistics. */
  dimensionValueStats: DimensionValueStats[];
}

export interface ResultStatus {
  /** whether the result was derived from incomplete Solr data */
  partialResults: boolean;
}

export interface SampleOptions {
  /**
   * Sample percent should be in range [1 to 100] when set.
   * If set, forces a certain sample size (100 forcing full results).
   * If unset (0), results in automatic smart selection based on request and org size (resulting in full resolution for most orgs).
   */
  percent: number;
}

export interface SampleResults {
  /**
   * Sample percent at which results were produced.
   * Supported APIs will extrapolate numbers to look like they were produced at 100%.
   */
  percent: number;
}

export interface IterativeOptions {
  /**
   * The iterative step being processed.
   * If 0, sampling is still supported, but actual iterative data will not be available from Solr for further steps.
   * If > 0, iteration is in process and returned data from Solr can be used for further steps.
   */
  step: number;
  /**
   * The current iterative state.
   * Empty for the first step, set for the remainder of the steps.
   * Should come from previous iterative results state (see docs there for more details).
   */
  state: string;
  /**
   * Iterative percent should be in range [1 to 100].
   * It is the percent of data being processed (starting at percent_offset) for this iteration.
   */
  percent: number;
  /**
   * Iterative percent offset should be in range [0 to 99].
   * It is the offset of data being processed (in whole unit percentages) for this iteration.
   */
  percentOffset: number;
  /**
   * Indicates whether or not to request a concise response from Solr when iterating.
   * Each iterative step will only request the iterative state (eliding the response data from Solr).
   * The final step will only request the response data (eliding the iterative state from Solr).
   * TODO(clay): remove this once all APIs support by default
   */
  conciseResponse: boolean;
}

export interface IterativeResults {
  /**
   * The iterative state as a result of this iteration.
   * If further iterations are required, this value should be supplied in the next iterative options.
   * This string value is an opaque string (typically base64 encoded binary data) sent from Solr containing the
   * current iterative state. It could be a large payload in some cases, so handle accordingly.
   */
  state: string;
}

export interface ListIndividualsRequest {
  /** Page info for the request.  The `skip` parameter is not used. */
  pageInfo: pagination.PageInfoRequest | null;
  /** ID for the org whose users we will be listing */
  orgId: string;
  /** Any filters to filter down what users we will be fetching. */
  userFilters: segment.UserFilter[];
}

export interface ListIndividualsResponse {
  /**
   * Page info for the response.  `previous_page_token` is not used.
   * `next_page_token` will be filled unless this is the final page.
   */
  pageInfo: pagination.PageInfoResponse | null;
  /**
   * Info for the users. The number of results will be equal to the
   * `total_records` field in the page info of the request, or less if this
   * is the final page (including 0 entries).
   */
  individuals: Individual[];
}

export interface Individual {
  /** The id of the individual */
  indvId: protobuf.int64;
  appKey: string;
}

export interface ListEventsRequest {
  pageInfo: pagination.PageInfoRequest | null;
  orgId: string;
  /** solr time range */
  timeRange: segment.TimeRange | null;
  event: segment.Event | null;
  /** Optional timezone, defaults to UTC if not provided */
  timezone: string;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
}

export interface ListEventsResponse {
  pageInfo: pagination.PageInfoResponse | null;
  events: Event[];
}

export interface Event {
  eventId: string;
  eventName: string;
  eventType: string;
  eventTime: protobuf.timestamp | null;
  sessionId: protobuf.int64;
  userId: protobuf.int64;
  properties: vars.Var[];
  sessionLink: string;
}
